import TestimonialCard from '~/components/Molecules/TestimonialCard/TestimonialCard.vue'

export default {
  props: {
    title: {
      type: String,
    },
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      //isMobile: null,
      card: TestimonialCard,
      swiperOptions: {
        watchOverflow: true,
        observer: true,
        slidesPerView: 1.2,
        spaceBetween: 24,
        grabCursor: true,
        breakpoints: {
          480: {
            slidesPerView: 1.8,
            spaceBetween: 28,
          },
          845: {
            slidesPerView: 2,
            spaceBetween: 28,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 28,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },
}
